import { plainToClass } from "class-transformer";
import { DocumentLibraryLoaderWithSharepoint } from '../../../shared/components/document-library/document-library-loader';

export class NewslettersPage {
    private documentViewModal: JQuery<HTMLElement>; // Declare `documentViewModal` as a class property

    constructor() {
        // Initialize the modal reference
        this.documentViewModal = $("#view-document-modal");

        if (typeof window !== "undefined" && typeof document !== "undefined") {
            if (document.readyState !== "loading") {
                this.initializeCarousel();
                this.initializeExpandToggle();
              
            } else {
                document.addEventListener("DOMContentLoaded", () => {
                    this.initializeCarousel();
                    this.initializeExpandToggle();
                
                });
            }
        }
    }

    private initializeExpandToggle(): void {
        const expandBtn = document.getElementById("carouselExpand") as HTMLButtonElement | null;
        const carousel = document.getElementById("CarouselContainer");
        const grid = document.getElementById("GridContainer");
        const arrowCol = document.querySelector(".arrow-col") as HTMLElement | null;
        if (!expandBtn || !carousel || !grid || !arrowCol) return;

        let expanded = false;

        // Helper to set button content with icon and text
        function setExpandButton(isExpanded: boolean) {
            if (isExpanded) {
                expandBtn.innerHTML = `<i class="fa fa-minimize mr-1" aria-hidden="true"></i> Collapse`;
            } else {
                expandBtn.innerHTML = `<i class="fa fa-expand mr-1" aria-hidden="true"></i> Expand`;
            }
        }

        setExpandButton(expanded);

        expandBtn.addEventListener("click", () => {
            expanded = !expanded;
            if (expanded) {
                carousel.style.display = "none";
                grid.style.display = "block";
                arrowCol.classList.add("disabled");
            } else {
                carousel.style.display = "block";
                grid.style.display = "none";
                arrowCol.classList.remove("disabled");
            }
            setExpandButton(expanded);
        });
    }

   

    // --------- Added: Pure JS Grid/Flex Carousel Logic ---------
    private initializeCarousel(): void {
        const track = document.getElementById('CarouselTrack');
        if (!track) return;

        // Step 1: Add no-transition for instant positioning
        track.classList.add('no-transition');

        function getItemsPerView(): number {
            return window.innerWidth >= 992 ? 4 : 1; // 4 items for desktop, 1 for mobile
        }

        const items = Array.from(track.children) as HTMLElement[];
        const totalItems = items.length;


        const carouselContainer = document.getElementById('CarouselContainer');
        const defaultIndex = carouselContainer
            ? parseInt(carouselContainer.getAttribute('data-default-index') || '0', 10)
            : 0;
        let currentIndex = defaultIndex; // Current visible index

        // Controls
        const prevBtn = document.getElementById('carouselPrev');
        const nextBtn = document.getElementById('carouselNext');
        const resetBtn = document.getElementById('carouselReset');

        // Update the state of the arrow controls
        function updateArrowStates(): void {
            const itemsPerViewNow = getItemsPerView();
            if (prevBtn) {
                const atFirstItem = currentIndex <= 0;
                prevBtn.classList.toggle('disabled', atFirstItem);
                prevBtn.setAttribute('aria-disabled', String(atFirstItem));
            }
            if (nextBtn) {
                const atLastItem = currentIndex >= totalItems - itemsPerViewNow;
                nextBtn.classList.toggle('disabled', atLastItem);
                nextBtn.setAttribute('aria-disabled', String(atLastItem));
            }
        }

        // Update carousel position
        function updateCarousel(): void {
            const itemsPerViewNow = getItemsPerView();
            const itemWidth = items[0].offsetWidth;

            if (currentIndex > totalItems - itemsPerViewNow) {
                currentIndex = Math.max(0, totalItems - itemsPerViewNow);
            }
            if (currentIndex < 0) {
                currentIndex = 0;
            }

            const moveX = currentIndex * itemWidth;

            // Animate the movement using CSS transform
            track.style.transform = `translateX(-${moveX}px)`;
            updateArrowStates();
        }

        // Navigate to the previous slide
        function prev(): void {
            if (currentIndex > 0) {
                currentIndex--;
                updateCarousel();
            }
        }

        // Navigate to the next slide
        function next(): void {
            const itemsPerViewNow = getItemsPerView();
            if (currentIndex < totalItems - itemsPerViewNow) {
                currentIndex++;
                updateCarousel();
            }
        }

        // Reset the carousel to the default index
        function reset(): void {
            currentIndex = defaultIndex;
            updateCarousel();
        }

        // Add event listeners for controls
        if (prevBtn && nextBtn) {
            prevBtn.addEventListener('click', (e) => {
                e.preventDefault();
                if (!prevBtn.classList.contains('disabled')) prev();
            });
            nextBtn.addEventListener('click', (e) => {
                e.preventDefault();
                if (!nextBtn.classList.contains('disabled')) next();
            });
        }

        if (resetBtn) {
            resetBtn.addEventListener('click', (e) => {
                e.preventDefault();
                reset();
            });
        }


        window.addEventListener('resize', () => {
            updateCarousel();
        });

        // Step 2: Instantly position carousel
        updateCarousel();

        // Step 3: Remove the no-transition class after initialization
        setTimeout(() => {
            track.classList.remove('no-transition'); 
        }, 30); 
    }
    //Modal for buttons
    viewDocument(link: string, title: string = "") {
        $("#filename").text(title); // Set modal title
        let iframe = this.documentViewModal.find("#document-iframe");
        iframe.attr("src", link);  // Set iframe source to the document link
        this.documentViewModal.modal("show"); // Show the modal
    }
}